module.exports = __webpack_public_path__ + "img/缴费记录.40a42b73.png";